import React from "react";

const CloseIcon = () => {
  return (
    <svg width="24" height="24" role="img" aria-label="Close" viewBox="0 0 24 24" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M3.51461 3.35355C3.70987 3.15829 4.02012 3.15196 4.20758 3.33941L20.4993 19.6312C20.6868 19.8186 20.6804 20.1289 20.4852 20.3241C20.2899 20.5194 19.9797 20.5257 19.7922 20.3383L3.50047 4.04652C3.31302 3.85907 3.31935 3.54882 3.51461 3.35355Z" fill="white" stroke="white" strokeWidth="0.5" strokeLinecap="round" />
      <path fillRule="evenodd" clipRule="evenodd" d="M3.51469 20.3536C3.31942 20.1583 3.31309 19.848 3.50054 19.6606L19.7923 3.36885C19.9797 3.1814 20.29 3.18773 20.4852 3.38299C20.6805 3.57825 20.6868 3.8885 20.4994 4.07596L4.20765 20.3677C4.0202 20.5551 3.70995 20.5488 3.51469 20.3536Z" fill="white" stroke="white" strokeWidth="0.5" strokeLinecap="round" />
    </svg>
  );
};

export default CloseIcon;
